import { FooterAd } from '@gagovictor/shared-frontend-core/dist/ads';
import React from 'react';

import { useT } from '../i18n';

import { config } from './config';

/** The web footer ad bar, from the shared core. The parent decides whether to render it (web, not lifetime, ads configured). */
export const AppFooterAd: React.FC = () => {
    const t = useT();
    return (
        <FooterAd
            client={config.adsenseClient}
            slot={config.adsenseFooterSlot}
            preview={config.adsPreview}
            test={config.adsenseTest}
            labels={{
                advertisement: t('ads.advertisement'),
                preview: t('ads.footerPreview'),
            }}
            links={[
                { to: '/about', label: t('footer.about') },
                { to: '/privacy-policy', label: t('footer.privacy') },
            ]}
        />
    );
};
